import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2, MapPin, X } from 'lucide-react';
const NAMES = ['María', 'Sofía', 'Lucía', 'Camila', 'Valentina', 'Martina', 'Florencia', 'Agustina', 'Carolina', 'Julieta', 'Mariana', 'Daniela', 'Romina', 'Gabriela', 'Belén', 'Andrea', 'Paula', 'Natalia', 'Lorena', 'Verónica', 'Juan', 'Matías', 'Nicolás', 'Diego', 'Lucas', 'Federico', 'Martín', 'Sebastián', 'Pablo', 'Tomás', 'Gonzalo', 'Esteban', 'Hernán', 'Maximiliano', 'Ramiro'];
const LAST_INITIALS = ['G.', 'M.', 'R.', 'L.', 'S.', 'B.', 'F.', 'C.', 'D.', 'P.', 'A.', 'T.', 'V.', 'H.', 'N.'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'San Miguel de Tucumán', 'Salta', 'Santa Fe', 'San Juan', 'Resistencia', 'Neuquén', 'Posadas', 'Bahía Blanca', 'Paraná', 'Corrientes', 'Río Cuarto', 'San Luis', 'Comodoro Rivadavia', 'Bariloche', 'Quilmes', 'Tandil', 'Concordia', 'Formosa'];
const OFFERS = ['Sistema Completo Sin Gluten', 'Pack Recetas + 6 Bonos'];
const pick = <T,>(arr: T[]): T => arr[Math.floor(Math.random() * arr.length)];
interface Purchase {
  id: number;
  name: string;
  city: string;
  offer: string;
  minutesAgo: number;
}
export function PurchaseToast() {
  const [current, setCurrent] = useState<Purchase | null>(null);
  useEffect(() => {
    let dismissTimer: ReturnType<typeof setTimeout>;
    let nextTimer: ReturnType<typeof setTimeout>;
    const showOne = () => {
      const purchase: Purchase = {
        id: Date.now(),
        name: `${pick(NAMES)} ${pick(LAST_INITIALS)}`,
        city: pick(CITIES),
        offer: pick(OFFERS),
        minutesAgo: Math.floor(Math.random() * 12) + 2
      };
      setCurrent(purchase);
      // Auto-dismiss after 6s
      dismissTimer = setTimeout(() => {
        setCurrent(null);
        // Schedule next between 40-60s after dismiss
        const delay = (Math.floor(Math.random() * 21) + 40) * 1000;
        nextTimer = setTimeout(showOne, delay);
      }, 6000);
    };
    // First popup after a short delay (8s)
    nextTimer = setTimeout(showOne, 8000);
    return () => {
      clearTimeout(dismissTimer);
      clearTimeout(nextTimer);
    };
  }, []);
  const handleClose = () => {
    setCurrent(null);
  };
  return <div className="fixed bottom-4 left-4 right-4 sm:right-auto sm:bottom-6 sm:left-6 z-50 pointer-events-none" data-id="element-144">
      <AnimatePresence data-id="element-145">
        {current && <motion.div key={current.id} initial={{
        opacity: 0,
        y: 40,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="pointer-events-auto bg-warm-white border border-sage/20 shadow-warm-lg rounded-2xl p-4 max-w-sm w-full sm:w-[360px] flex items-center gap-3 relative" data-id="element-146">
            <div className="w-12 h-12 rounded-full bg-sage/15 flex items-center justify-center flex-shrink-0" data-id="element-147">
              <CheckCircle2 className="w-7 h-7 text-sage" data-id="element-148" />
            </div>

            <div className="flex-1 min-w-0 pr-5" data-id="element-149">
              <div className="flex items-center gap-1.5 mb-0.5" data-id="element-150">
                <span className="text-[10px] font-bold uppercase tracking-widest text-sage bg-sage/10 px-2 py-0.5 rounded-full" data-id="element-151">
                  Compra verificada
                </span>
              </div>
              <p className="text-sm text-charcoal leading-snug" data-id="element-152">
                <span className="font-semibold" data-id="element-153">{current.name}</span>
                <span className="text-muted" data-id="element-154"> compró el </span>
                <span className="font-semibold" data-id="element-155">{current.offer}</span>
              </p>
              <div className="flex items-center gap-3 mt-1 text-xs text-muted" data-id="element-156">
                <span className="flex items-center gap-1" data-id="element-157">
                  <MapPin className="w-3 h-3" data-id="element-158" />
                  {current.city}
                </span>
                <span data-id="element-159">Hace {current.minutesAgo} min</span>
              </div>
            </div>

            <button onClick={handleClose} aria-label="Cerrar notificación" className="absolute top-2 right-2 w-6 h-6 rounded-full hover:bg-cream flex items-center justify-center text-muted hover:text-charcoal transition-colors" data-id="element-160">
              <X className="w-3.5 h-3.5" data-id="element-161" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}